// Единый источник правды о структуре сайта: языки, страницы, URL.
// Используется и в браузере, и при пререндере (scripts/prerender.mjs).

export const SITE_URL = 'https://algarve-quest.com';

export const LANGS = ['en', 'pt', 'ru'] as const;
export type Lang = (typeof LANGS)[number];
export const DEFAULT_LANG: Lang = 'en';

/** Значение атрибута <html lang> и hreflang. */
export const HTML_LANG: Record<Lang, string> = { en: 'en', pt: 'pt-PT', ru: 'ru' };
export const OG_LOCALE: Record<Lang, string> = { en: 'en_GB', pt: 'pt_PT', ru: 'ru_RU' };

export const QUEST_IDS = ['faro', 'olhao', 'alte'] as const;
export type QuestId = (typeof QUEST_IDS)[number];

export type PageId = 'home' | QuestId | 'team';

/** Слаги страниц. Одинаковые для всех языков. */
export const PAGE_SLUGS: Record<PageId, string> = {
  home: '',
  faro: 'faro-quest',
  olhao: 'olhao-quest',
  alte: 'alte-quest',
  team: 'team-building-algarve',
};

export const PAGE_IDS = Object.keys(PAGE_SLUGS) as PageId[];

export function isLang(value: string | undefined): value is Lang {
  return !!value && (LANGS as readonly string[]).includes(value);
}

/** Относительный путь страницы, всегда с завершающим слешем: /en/faro-quest/ */
export function pagePath(page: PageId, lang: Lang): string {
  const slug = PAGE_SLUGS[page];
  return slug ? `/${lang}/${slug}/` : `/${lang}/`;
}

export function pageUrl(page: PageId, lang: Lang): string {
  return `${SITE_URL}${pagePath(page, lang)}`;
}

/** Определяет язык по пути (/pt/... → pt). */
export function langFromPath(pathname: string): Lang {
  const first = pathname.split('/').filter(Boolean)[0];
  return isLang(first) ? first : DEFAULT_LANG;
}

/** Факты о маршрутах, общие для всех языков. Источник: каталог квестов и текущий сайт. */
export const QUESTS: Record<
  QuestId,
  { locations: number; routeKm: number; age: string; lat: number; lng: number; image: string; imageW: number; imageH: number }
> = {
  faro: { locations: 16, routeKm: 1.05, age: '12+', lat: 37.0159084, lng: -7.9356004, image: '/IMG_2277.JPG', imageW: 1200, imageH: 900 },
  olhao: { locations: 13, routeKm: 1.54, age: '7+', lat: 37.0222868, lng: -7.8482566, image: '/IMG_2276.JPG', imageW: 1028, imageH: 768 },
  alte: { locations: 16, routeKm: 1.46, age: '7+', lat: 37.2363607, lng: -8.1767192, image: '/img/alte-1200.jpg', imageW: 1200, imageH: 800 },
};

export const PRICE_EUR = '12.50';

export function playUrl(quest: QuestId, lang: Lang): string {
  return `https://play.algarve-quest.com/quest/${quest}/description?lang=${lang}`;
}

export function mapUrl(quest: QuestId): string {
  const q = QUESTS[quest];
  return `https://www.google.com/maps/search/?api=1&query=${q.lat},${q.lng}`;
}

export const CONTACTS = {
  whatsappDisplay: '+351 911 540 083',
  whatsappLink: 'https://wa.me/351911540083',
  email: 'algarvequest@gmail.com',
  instagram: 'https://www.instagram.com/algarve_quest',
  facebook: 'https://www.facebook.com/profile.php?id=61550092716283',
};
